import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable, take, tap } from 'rxjs';
import { AuthenticationService } from '../authentication';

export const AuthorizationGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.getIsAuthorized().pipe(
    take(1),
    tap((result): void => {
      if (!result?.isAuthenticated) {
        const url = state.url || authService.getCurrentPath().currentPath;
        authService.setRedirectUrl(url);
        router.navigate(['/home']);
      }
    }),
    map((result): boolean => !!result?.isAuthenticated),
  );
};
